import * as React from 'react';
import { useContext } from 'react';

import type { BrowseSkillNamesByIds_SkillFieldsFragment as RelatedSkillFragment } from 'bundles/page-config-common/queries/__generated__/BrowseSkillNamesByIds';

export type RelatedSkillsContextType = {
  skills?: RelatedSkillFragment[];
};

const RelatedSkillsContext = React.createContext<RelatedSkillsContextType | undefined>(undefined);

export const useRelatedSkills = () => {
  return useContext(RelatedSkillsContext);
};

export default RelatedSkillsContext;
